<template>
  <v-dialog v-model="dialog" :scrollable="scrollable" :persistent="persistent" :max-width="width" :content-class="classList" @input="closeModal">
    <v-card class="px-4 pt-4 pb-4">
      <v-card-title>
        <h2>
          {{ title }}
        </h2>
      </v-card-title>
      <v-card-text>
        <v-layout row wrap py-2 px-4>
          <v-flex xs12>
            <v-form row wrap ref="form" @submit.prevent="save()">
              <slot name="content"></slot>
            </v-form>
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-card-actions>
        <v-layout>
          <v-flex md4 v-if="hasMore" class="text-xs-left">
            <v-btn flat color="k-orange-linear-text" @click="showMore()" :disabled="more">
              MAS
            </v-btn>
          </v-flex>
          <v-flex :class="{'text-xs-right': true, 'md8': hasMore, 'xs12': !hasMore}" pr-4>
            <v-btn flat color="black" @click="closeModal()" v-if="cancelButton">
              CANCELAR
            </v-btn>
            <v-btn
              class="k-orange-linear-text"
              flat
              @click.native="type === 'saver' || edit ? downloadDialog ? download() : save() : sendForm()"
              :disabled="errors.any() || disableSaveBtn">
              GUARDAR
            </v-btn>
          </v-flex>
        </v-layout>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import EventBus from '@/event-bus';

export default {
  inject: ['$validator'],
  props: {
    type: {
      type: String,
      default: 'saver',
    },
    title: {
      type: String,
      required: true,
    },
    dialog: {
      type: Boolean,
      required: true,
    },
    form: {
      type: Object,
      required: true,
    },
    route: {
      type: String,
      required: true,
    },
    edit: {
      type: Boolean,
      default: false,
    },
    cancelButton: {
      type: Boolean,
      default: true,
    },
    hasMore: {
      type: Boolean,
      default: true,
    },
    more: {
      type: Boolean,
      required: true,
    },
    scrollable: {
      type: Boolean,
      default: true,
    },
    classList: {
      type: String,
      default: '',
    },
    width: {
      type: String,
      default: '600px',
    },
    clearformed: null,
    downloadDialog: {
      type: Boolean,
      default: false,
    },
    persistent: {
      type: Boolean,
      default: true,
    },
    bus: {
      type: Object,
      default() {
        return {
          created: 'created',
          updated: 'updated',
          modalOpened: 'modalOpened',
          showMore: 'showMore',
          closeModal: 'closeModal',
          openRightDrawer: 'openRightDrawer',
          solved: 'markSolved',
        };
      },
    },
    disableSaveBtn: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    sendForm() {
        EventBus.$emit('formData', this.form);
    },
    save() {
      if (!this.edit) {
        this.axios.post(this.route, this.form).then((response) => {
          if (response.data.id) {
            EventBus.$emit(this.bus.created, response.data.id);
          } else if (response.data.chat_center_message) {
            EventBus.$emit(this.bus.solved, response.data);
          } else if (response.data.message) {
            EventBus.$emit('modal', response.data.message);
          }
          EventBus.$emit('update');
        }).catch((error) => {
          if (error.response.status === 418) {
            EventBus.$emit('modal', error.response.data);
          }
          if (error.response.status === 403) {
            EventBus.$emit('modal', error.response.data.message);
          }
        });
      } else {
        this.axios.patch(this.route, this.form).then(() => {
          EventBus.$emit(this.bus.updated);
          EventBus.$emit('update');
        }).catch((error) => {
          EventBus.$emit('errorSaveDialog', error);
        });
      }
    },
    closeModal() {
      this.$emit(this.bus.closeModal);
      EventBus.$emit(this.bus.closeModal, this.clearformed);
    },
    showMore() {
      EventBus.$emit(this.bus.showMore);
    },
    download() {
      this.axios({
        url: this.route,
        method: 'GET',
        responseType: 'blob',
      }).then((response) => {
        if (!window.navigator.msSaveOrOpenBlob) {
          // BLOB NAVIGATOR
          const url = window.URL.createObjectURL(response.data);
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', `base_${this.form.type}.xlsx`);
          document.body.appendChild(link);
          link.click();
        } else {
          // BLOB FOR EXPLORER 11
          window.navigator.msSaveOrOpenBlob(response.data, `base_${this.form.type}.xlsx`);
        }
      });
    },
  },
  watch: {
    dialog(newVal) {
      if (newVal) {
        EventBus.$emit(this.bus.modalOpened, this.edit, this.clearformed);
      }
    },
  },
};

</script>


// WEBPACK FOOTER //
// src/components/global/SaveDialog.vue